import React from 'react';
import { formatPercentage as formatPercentageShared } from 'semshared/utils/format';

interface PercentageProps {
  percentage: number;
  precision?: number;
}

/**
 * Formats percentage value using Austrian German locale.
 */
export function formatPercentage(percentage: number, precision: number = 0) {
  return formatPercentageShared(percentage, 'de-AT', precision);
}

/**
 * React component for displaying formatted percentage.
 */
export default function Percentage(props: PercentageProps) {
  const { percentage, precision } = props;

  return <>{formatPercentage(percentage, precision)}</>;
}
